import {Routes} from '@angular/router';

import {genericResourceRoutes} from '@catcore/shared/routes';
import {ProjectDiagramComponent} from '@catdetails/components';
import {FeaturesComponent} from '@catdetails/components/features/features.component';
import {CreateGuiZoneComponent} from '@catdetails/components/gui-zone/create-gui-zone/create-gui-zone.component';
import {GuiZonesComponent} from '@catdetails/components/gui-zone/gui-zones/gui-zones.component';
import {ProjectLopaPositionsComponent} from '@catdetails/components/project-lopa-positions/project-lopa-positions.component';
import {ProjectMediaSourcesComponent,
} from '@catmodules/models/project-media-sources/components/project-media-sources/project-media-sources.component';
import {
  ProjectDetailsComponent,
  ProjectPropertiesComponent,
} from './components';
import {CurrentProjectResolve, ProjectResolve} from './resolve';
import {UploadFilesComponent} from "app/modules/project-details/components/userdata-file/userdata-files/upload-files.component";
import {TestRackComponent} from "@catdetails/components/test-rack/test-rack.component";
import {TestRackSetupComponent} from "@catmodules/models/test-rack/components/test-rack-setup/test-rack-setup.component";
import {TestRackUnitAssignmentComponent} from "@catmodules/models/test-rack/components/test-rack-unit-assignment/test-rack-unit-assignment.component";
import {PatchFieldLinksComponent} from "@catmodules/models/test-rack/components/patch-field-links/patch-field-links.component";
import {ProjectOptionTokensComponent} from "@catmodels/project-option-tokens/components/project-option-tokens/project-option-tokens.component";
import {ParameterSearch} from "@catmodels/project-parameters/components/parameter-search/parameter-search.component";
import {GgwDevZoneAssignmentComponent} from "@catmodels/ggw-dev-zone-assignment/components/ggw-dev-zone-assignment/ggw-dev-zone-assignment.component";
import {GgwComponent} from "@catdetails/components/ggw/ggw.component";
import {GgwProfilesComponent} from "@catmodels/ggw-profiles/components/ggw-profiles/ggw-profiles.component";
import {GgwDeviceAccessComponent} from "@catmodels/ggw-profiles/components/ggw-device-access/ggw-device-access.component";
import {ProjectGgwFixedRouteListComponent} from "@catmodels/ggw-fixed-routes/components/project-ggw-fixed-route-list/project-ggw-fixed-route-list.component";
import {GgwDynamicRoutesComponent} from "@catmodels/ggw-dynamic-routes/components/ggw-dynamic-routes/ggw-dynamic-routes.component";
import {GgwDynamicRouteTemplatesComponent} from "@catmodels/ggw-dynamic-routes/components/ggw-dynamic-route-templates/ggw-dynamic-route-templates.component";
import {NewGgwDynamicRouteTemplateComponent} from "@catmodels/ggw-dynamic-routes/components/new-ggw-dynamic-route-template/new-ggw-dynamic-route-template.component";
import {ProjectPartnumbersComponent} from "@catmodels/project-partnumbers/components/project-partnumbers/project-partnumbers.component";
import {ProjectAppSelectionsComponent} from "@catmodels/project-partnumbers/components/project-app-selections/project-app-selections.component";
import {ProjectUnitPartnumbersComponent} from "@catmodels/project-partnumbers/components/project-unit-partnumbers/project-unit-partnumbers.component";
import {ProjectSpeakerSetupComponent} from "@catmodels/project-speaker-setup/components/project-speaker-setup/project-speaker-setup.component";
import {InputAssignmentComponent} from "@catmodels/project-speaker-setup/components/input-assignment/input-assignment.component";
import {ProjectAvodCatalogsComponent} from "@catmodels/avod-catalog/components/project-avod-catalogs/project-avod-catalogs.component";
import {path} from "d3-path";
import {ProjectAvodComponent} from "@catmodels/project-avod/components/project-avod/project-avod.component";
import {EvidComponent} from "@catdetails/components/evid/evid.component";
import {EvidFunctionsComponent} from "@catmodels/evid-functions/components/evid-functions/evid-functions.component";
import {EvidDebugComponent} from "@catmodels/evid-functions/components/evid-debug/evid-debug.component";
import {UserdataGenerationComponent} from "@catdetails/components/userdata-generation/userdata-generation.component";
import {UserdataGenerationBriefingsComponent} from "@catmodules/models/userdata-generation/components/userdata-generation-briefings/userdata-generation-briefings.component";
import {ProjectServiceFilesComponent} from "@catmodels/project-service-files/components/project-service-files/project-service-files.component";
import {ProjectChecklistComponent} from "@catmodels/project-checklist/components/project-checklist/project-checklist.component";

export const routes: Routes = [
  {
    path: ':projectId',
    component: ProjectDetailsComponent,
    resolve: {
      category: ProjectResolve,
    },
    children: [
      {
        path: 'properties',
        component: ProjectPropertiesComponent,
      },
      {
        path: 'features',
        component: FeaturesComponent,
      },
      {
        path: 'gui-zones',
        component: GuiZonesComponent,
        children: [
          {
            path: 'new',
            component: CreateGuiZoneComponent,
          },
          ...genericResourceRoutes,
        ],
      },
      {
        path: 'upload-files',
        component: UploadFilesComponent,
      },
      {
        path: 'sbd',
        component: ProjectDiagramComponent,
      },
      {
        path: 'parameters',
        component: ParameterSearch,
      },
      {
        path: 'checklist',
        component: ProjectChecklistComponent,
      },
      {
        path: 'service-files',
        component: ProjectServiceFilesComponent,
      },
      {
        path: 'speaker-setup',
        component: ProjectSpeakerSetupComponent,
        children: [
          {
            path: 'input-assignment',
            component: InputAssignmentComponent
          },
        ]
      },
      {
        path: 'evid',
        component: EvidComponent,
        children: [
          {
            path: 'evid-functions',
            component: EvidFunctionsComponent,
          },
          {
            path: 'evid-debug',
            component: EvidDebugComponent,
          },
        ]
      },
      {
        path: 'ggw',
        component: GgwComponent,
        children: [
          {
            path: 'ggw-device-zone-assignments',
            component: GgwDevZoneAssignmentComponent,
          },
          {
            path: 'ggw-access-profiles',
            component: GgwProfilesComponent,
          },
          {
            path: 'ggw-device-access',
            component: GgwDeviceAccessComponent,
          },
          {
            path: 'ggw-fixed-routes',
            component: ProjectGgwFixedRouteListComponent,
          },
          {
            path: 'ggw-dynamic-route-templates',
            component: GgwDynamicRouteTemplatesComponent,
            children: [
              {
                path: 'new',
                component: NewGgwDynamicRouteTemplateComponent,
              },
              ...genericResourceRoutes
            ]
          },
          {
            path: 'ggw-dynamic-routes',
            component: GgwDynamicRoutesComponent,
          },
        ]
      },
      {
        path: 'partnumbers',
        component: ProjectPartnumbersComponent,
        children: [
          {
            path: 'units',
            component: ProjectUnitPartnumbersComponent,
          },
          {
            path: 'services',
            component: ProjectAppSelectionsComponent,
          },
        ]
      },
      {
        path: 'test-rack',
        component: TestRackComponent,
        children: [
          {
            path: 'setup',
            component: TestRackSetupComponent,
          },
          {
            path: 'units',
            component: TestRackUnitAssignmentComponent
          },
          {
            path: 'patch-field',
            component: PatchFieldLinksComponent
          }
        ],
      },
      {
        path: 'packages-generation',
        component: UserdataGenerationComponent,
        children: [
          {
            path: 'user-data',
            component: UserdataGenerationBriefingsComponent,
          }
        ],
      },
      {
        path: 'tokens',
        component: ProjectOptionTokensComponent,
      },
      {
        path: 'avod',
        component: ProjectAvodComponent,
        children: [
          {
            path: 'project-avod-catalogs',
            component: ProjectAvodCatalogsComponent,
          },
          {
            path: 'project-media-sources',
            component: ProjectMediaSourcesComponent,
          },
        ],
      },
      {
        path: 'lopa-positions',
        component: ProjectLopaPositionsComponent,
      },
    ],
  },
];



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_master@2/app/Resources/Public/src/app/modules/project-details/project-details.routing.ts